/* angular:styles/component:css;540a1832c608631a228ed7e1a987129adac9bb4ee297f7d386a0155767016839;/src/src/app/shared/components/formly/form-field.wrapper.ts */
formly-field-ion-toggle,
formly-field-ion-checkbox,
formly-custom-select,
formly-input-serial-number,
formly-custom-select {
  width: 100%;
}
formly-field-ion-toggle,
ion-toggle {
  padding: 0 !important;
  margin: 0 !important;
  transform: none !important;
}
ion-toggle::part(label),
ion-checkbox::part(label),
ion-radio::part(label) {
  white-space: pre-wrap !important;
  flex: 1;
  margin-inline-end: 0 !important;
}
formly-field .sc-ion-label-md-s p,
formly-field ion-label p {
  color: var(--ion-text-description-color) !important;
}
.helper-text,
.hint-text,
ion-note.helper-text {
  color: var(--ion-text-description-color) !important;
}
/*# sourceMappingURL=form-field.wrapper.css.map */
